/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/suppression_rules" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdSuppressionRules } from "./constants";
import type {
  EngagementAppGroupIdSuppressionRulesParams,
  GetEngagementAppGroupIdSuppressionRulesResult,
} from "./types";
import { isGetEngagementAppGroupIdSuppressionRulesResult } from "./validators";

export const getDataTableEngagementAppGroupIdSuppressionRules = reactQueryTableFetcherAdapter(
  engagementAppGroupIdSuppressionRules,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, limit = 20, start = 0, sortdir, sortby }: EngagementAppGroupIdSuppressionRulesParams
  ): Promise<GetEngagementAppGroupIdSuppressionRulesResult> => {
    return fetch(
      `/engagement/${appGroupId}/suppression_rules`,
      "GET",
      {
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isGetEngagementAppGroupIdSuppressionRulesResult
);
